/* eslint-disable react/prop-types */
import {
  Col,
  Form,
  Row,
  Spin,
} from 'antd';
import Select from 'components/Select';
import React from 'react';
import { getModelPermission } from 'utils/permission';
import UsuariosPermisosTiposDeNominaEmpleado, { usuariosPermisosEmpleadosPermission } from './UsuariosPermisosTiposDeNominaEmpleados';
import UsuariosPermisosAreas, { usuariosPermisosAreasPermission } from './UsuariosPermisosAreas';

export const usuariosPermisosPermission = {
  permissionModel: 'usuariolimitaciondeinformacion',
  catalogsModels: [],
  tabsModels: [],
};

const UsuariosLimitaciones = ({
  form,
  areas,
  usuarioLimitacionId,
  rules,
  aplicaTNE,
  setAplicaTNE,
  aplicaArea,
  setAplicaArea,
  loading,
  disableEditar,
}) => {
  const getPermissionTipoNomina = getModelPermission(
    usuariosPermisosEmpleadosPermission.permissionModel,
    usuariosPermisosEmpleadosPermission.catalogsModels,
    usuariosPermisosEmpleadosPermission.tabsModels,
    false,
  );

  const getPermissionAreas = getModelPermission(
    usuariosPermisosAreasPermission.permissionModel,
    usuariosPermisosAreasPermission.catalogsModels,
    usuariosPermisosAreasPermission.tabsModels,
    false,
  );

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Form
          layout="vertical"
          form={form}
          scrollToFirstError
          name="limitaciones"
          initialValues={{
            aplica_limitacion_de_tipos_de_nomina_empleado: false,
            aplica_limitacion_de_area: false,
            aplica_cancelacion_registros_dias_guardia_autorizados: false,
            aplica_cancelacion_vacaciones_dias_disfrutados_autorizados: false,
            aplica_limitacion_de_autorizacion_de_contratacion: false,
            aplica_limitacion_de_autorizacion_de_plazas: false,
            aplica_limitacion_de_autorizacion_de_nombramientos: false,
          }}
        >
          <Row gutter={10}>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="aplica_limitacion_de_tipos_de_nomina_empleado"
                label="Acceso por Tipo de Nómina Empleado"
                hasFeedback
                rules={rules.required}
              >
                <Select
                  trueFalse
                  onChange={(value) => {
                    setAplicaTNE(value);
                    if (value) {
                      setAplicaArea(!value);
                      form.setFieldValue('aplica_limitacion_de_area', !value);
                    }
                  }}
                  disabled={disableEditar}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="aplica_limitacion_de_area"
                label="Acceso por Área"
                hasFeedback
                rules={rules.required}
              >
                <Select
                  trueFalse
                  onChange={(value) => {
                    setAplicaArea(value);
                    if (value) {
                      setAplicaTNE(!value);
                      form.setFieldValue('aplica_limitacion_de_tipos_de_nomina_empleado', !value);
                    }
                  }}
                  disabled={disableEditar}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="aplica_cancelacion_registros_dias_guardia_autorizados"
                label="Cancelación de Guardias Autorizadas"
                hasFeedback
                rules={rules.required}
              >
                <Select
                  trueFalse
                  disabled={disableEditar}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="aplica_cancelacion_vacaciones_dias_disfrutados_autorizados"
                label="Cancelación de Vacaciones Disfrutadas Autorizadas"
                hasFeedback
                rules={rules.required}
              >
                <Select
                  trueFalse
                  disabled={disableEditar}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="aplica_limitacion_de_autorizacion_de_contratacion"
                label="Puede Autorizar Contrataciones"
                hasFeedback
                rules={rules.required}
              >
                <Select
                  trueFalse
                  disabled={disableEditar}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="aplica_limitacion_de_autorizacion_de_plazas"
                label="Puede Autorizar Administración de Plazas"
                hasFeedback
                rules={rules.required}
              >
                <Select
                  trueFalse
                  disabled={disableEditar}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="aplica_limitacion_de_autorizacion_de_nombramientos"
                label="Puede Autorizar Nombramientos"
                hasFeedback
                rules={rules.required}
              >
                <Select
                  trueFalse
                  disabled={disableEditar}
                />
              </Form.Item>
            </Col>
            {usuarioLimitacionId && aplicaTNE ? (
              <UsuariosPermisosTiposDeNominaEmpleado
                permission={getPermissionTipoNomina}
                selected={usuarioLimitacionId}
                disableEditar={disableEditar}
              />
            ) : null}
            {usuarioLimitacionId && aplicaArea ? (
              <UsuariosPermisosAreas
                permission={getPermissionAreas}
                selected={usuarioLimitacionId}
                disableEditar={disableEditar}
              />
            ) : null}
          </Row>
        </Form>
      </Spin>
    </Row>
  );
};

export default UsuariosLimitaciones;
